import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAllTeamsApi } from "../../../../app/api";

export default function TeamsPage() {
  const navigate = useNavigate();
  const [teams, setTeams] = useState([]);
  const [activeTab, setActiveTab] = useState("ALL");

  const loadTeams = async () => {
    const res = await getAllTeamsApi();
    if (res?.success) {
      setTeams(res.data || []);
    }
  };

  useEffect(() => {
    loadTeams();
  }, []);

  const filteredTeams =
    activeTab === "ALL"
      ? teams
      : teams.filter((team) => team.status === activeTab);

  return (
    <div
      className="
        relative
        w-full
        bg-gradient-to-br
        from-[#1e1447]
        via-[#24155a]
        to-[#12082f]
        p-6 rounded-[24px] md:mt-20
        overflow-hidden
      "
    >
      {/* Floating Light */}
      <div className="absolute top-20 left-20 w-72 h-72 bg-white/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>
      <div className="absolute bottom-10 right-10 w-72 h-72 bg-purple-400/20 rounded-full blur-3xl opacity-20 pointer-events-none"></div>

      {/* HEADER */}
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-2xl font-semibold text-white">
          Teams
        </h2>

        {/* <div className="flex gap-3">
          {["ALL", "ACTIVE", "INACTIVE"].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`
                px-4 py-1 text-sm rounded-[10px]
                backdrop-blur-md shadow-lg
                border border-white/10
                transition-all duration-300
                ${
                  activeTab === tab
                    ? "bg-white/20 text-white"
                    : "bg-white/10 text-gray-300 hover:bg-white/15"
                }
              `}
            >
              {tab}
            </button>
          ))}
        </div> */}
      </div>

      {filteredTeams.length === 0 ? (
        <p className="text-gray-300">No teams available</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {filteredTeams.map((team) => (
            <div
              key={team.id}
              onClick={() =>
                navigate(`/dashboard/teams/${team.id}`)
              }
              className="
                relative
                overflow-hidden
                rounded-[20px]
                p-5
                backdrop-blur-2xl
                bg-white/5
                border border-white/20
                shadow-[0_10px_40px_rgba(0,0,0,0.35)]
                hover:bg-white/10
                transition-all duration-300
                cursor-pointer
              "
            >
              {/* Shine Effect */}
              <div className="absolute -top-16 -right-16 w-40 h-40 bg-white/50 rounded-full blur-2xl opacity-50 pointer-events-none"></div>

              {/* Team Name */}
              <h4 className="text-white font-semibold text-lg mt-2">
                {team.name}
              </h4>

              {/* Department */}
              <p className="text-gray-400 text-sm mt-2">
                Department: {team.department_name || "N/A"}
              </p>

              {/* Members Count */}
              <div className="flex justify-between text-xs text-gray-400 mt-4">
                <div>
                  <p>Members</p>
                  <p className="text-gray-300">
                    {team.members?.length || 0}
                  </p>
                </div>

                <div>
                  <p>Tasks</p>
                  <p className="text-gray-300">
                    {team.tasks_count || 0}
                  </p>
                </div>
              </div>

              {/* Progress Bar */}
              <div
                className="h-1 bg-gradient-to-r from-cyan-400 to-blue-500 rounded-full mt-3"
                style={{
                  width: team.progress
                    ? `${team.progress}%`
                    : "50%",
                }}
              />

              {/* Status Badge */}
              <div className="flex justify-end mt-2">
                <span
                  className={`
                    text-[8px] px-3 py-0.5 rounded-full font-medium
                    backdrop-blur-md border border-white/20
                    ${
                      team.status === "ACTIVE"
                        ? "bg-green-500/20 text-green-400"
                        : "bg-gray-500/20 text-gray-300"
                    }
                  `}
                >
                  {team.status || "ACTIVE"}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}